var _rect, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_278_2",
    "data-name": "Component 278 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3642",
    "data-name": "Rectangle 3642",
    width: 32,
    height: 32,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11347",
    "data-name": "Group 11347",
    transform: "translate(-16 -160)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3643",
    "data-name": "Rectangle 3643",
    transform: "translate(24 168)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 5.5,
    height: 7.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3644",
    "data-name": "Rectangle 3644",
    transform: "translate(33 175)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 5.5,
    height: 7.5,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3645",
    "data-name": "Rectangle 3645",
    transform: "translate(24 179)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 5.5,
    height: 3.5,
    fill: "none"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3646",
    "data-name": "Rectangle 3646",
    transform: "translate(33 168)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 5.5,
    height: 3.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.28f767a56a01964f67e08831355a310b.svg";
export { ForwardRef as ReactComponent };